import { isCheckoutEnabledPlan, normalizeCheckoutPlan } from "./plans.js";
import { SHORT_PREFERENCES_PATH } from "./preferences-route.js";

export const LANDING_SIGNED_IN_NAV_ITEMS = Object.freeze([
  {
    key: "preferences",
    label: "Preferences",
    href: SHORT_PREFERENCES_PATH,
  },
  {
    key: "account",
    label: "Account",
    href: "/account",
  },
]);

export function getLandingOwnedAccount(decision) {
  const account = decision?.accountPayload?.account;
  const status = String(account?.status || "").trim().toUpperCase();
  if (!account?.id || status === "DELETED") return null;
  const hasLinkedIdentity = Boolean(String(account.selfChatJid || "").trim())
    || (status === "WORKING" && Boolean(String(account.phoneNumber || "").trim()));
  return hasLinkedIdentity ? decision : null;
}

export function shouldRestartLandingInstantQr(intent, { enabled = false, desktop = false } = {}) {
  return enabled && desktop && intent?.type === "start" && intent?.plan === "fun";
}

export function buildLandingStartPath(plan = "free") {
  const normalizedPlan = typeof plan === "string" && plan ? plan : "free";
  const linkingSearchParams = new URLSearchParams();
  if (isCheckoutEnabledPlan(normalizedPlan)) {
    linkingSearchParams.set("selectedPlan", normalizeCheckoutPlan(normalizedPlan, "fun"));
  }
  return linkingSearchParams.size > 0 ? `/link?${linkingSearchParams.toString()}` : "/link";
}

export function buildLandingIntentPath(intent = null) {
  const type = String(intent?.type || "start").trim().toLowerCase();
  if (type === "sign-in") {
    return "/auth";
  }
  return buildLandingStartPath(intent?.plan);
}

export function getLandingCtaAnalyticsLabel(plan = "free") {
  const normalizedPlan = typeof plan === "string" && plan ? plan : "free";
  return `start_${normalizedPlan}`;
}

export function buildSignedInLandingDialogState({
  email = "",
  accountDestination = "link",
  anonymousAccount = false,
  pendingIntent = null,
} = {}) {
  const normalizedEmail = String(email || "").trim();
  const continuePath = buildLandingIntentPath(pendingIntent);
  const hasWorkingLinkedAccount = String(accountDestination || "").trim().toLowerCase() === "preferences";

  return {
    title: "You're already signed in",
    description: normalizedEmail
      ? `This browser is signed in as ${normalizedEmail}. Open your settings, or sign out before continuing with another account.`
      : "This browser is already signed in. Open your settings, or sign out before continuing with another account.",
    primaryAction: anonymousAccount || accountDestination === "setup"
      ? { label: "Configure Min", href: "/auth?context=linked" }
      : hasWorkingLinkedAccount
      ? {
          label: "View preferences",
          href: SHORT_PREFERENCES_PATH,
        }
      : {
          label: String(pendingIntent?.type || "").trim().toLowerCase() === "sign-in"
            ? "Continue to sign in"
            : "Continue linking",
          href: continuePath,
        },
    accountAction: hasWorkingLinkedAccount && !anonymousAccount
      ? {
          label: "Account",
          href: "/account",
        }
      : null,
    logoutAction: {
      label: "Log out and continue",
      href: continuePath,
    },
  };
}
